import React from 'react';
import { Icon } from 'semantic-ui-react';
import classnames from 'classnames';
import { formatNumber } from 'accounting';
import './SelectedVehicle.scss';

export interface SelectedVehicleProps {
  id?: string | number | undefined;
  name?: string | null;
  trim?: string | null;
  stock?: string | null;
  mileage?: number | null;
  isPrimary: boolean;
  isSelected: boolean;
  hasActiveChat: boolean;
  onRemoveVehicle: () => void;
  onEditMileage: () => void;
  onMakePrimary: () => void;
  onSelectVehicle: () => void;
}

const SelectedVehicle: React.FC<SelectedVehicleProps> = ({
  id,
  name,
  trim,
  stock,
  mileage,
  isPrimary,
  isSelected,
  hasActiveChat,
  onRemoveVehicle,
  onEditMileage,
  onMakePrimary,
  onSelectVehicle,
}) => {
  const editMileageHandler = (e: React.MouseEvent) => {
    e.stopPropagation();
    onEditMileage();
  };

  const makePrimaryHandler = (e: React.MouseEvent) => {
    e.stopPropagation();
    onMakePrimary();
  };

  const removeVehicleHandler = (e: React.MouseEvent) => {
    e.stopPropagation();
    onRemoveVehicle();
  };

  return (
    <div
      className={classnames('selected-vehicle-wrapper', {
        selected: isSelected,
      })}
      onClick={onSelectVehicle}
      aria-label="selected-vehicle"
    >
      <div className="content">
        <div className="name">{name}</div>
        <div>Trim: {trim}</div>
        <div>Stock: {stock}</div>
        <div>VIN: {id}</div>
        <div className="mileage">
          <span>Mileage: {formatNumber(mileage ?? 0)}</span>
          <Icon
            onClick={(e: React.MouseEvent) => editMileageHandler(e)}
            name="pencil"
            className="icon"
            aria-label="edit mileage"
          />
        </div>
        <div className="make-primary">
          {isPrimary ? (
            <div className="text">Primary vehicle</div>
          ) : (
            <div
              onClick={(e: React.MouseEvent) => makePrimaryHandler(e)}
              className="link"
            >
              Make primary
            </div>
          )}
        </div>
      </div>
      {!isPrimary && !hasActiveChat && (
        <Icon
          aria-label="remove vehicle button"
          onClick={(e: React.MouseEvent) => removeVehicleHandler(e)}
          name="close"
          className="close-icon"
        />
      )}
    </div>
  );
};

export default SelectedVehicle;
